var _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2ColumnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.1553,
    width: 10.4348,
    height: 10,
    rx: 2,
    fill: "#00322E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.1553,
    y: 14,
    width: 10.4348,
    height: 10,
    rx: 2,
    fill: "#00322E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 10.4348,
    height: 10,
    rx: 2,
    fill: "#00322E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 14,
    width: 10.4348,
    height: 10,
    rx: 2,
    fill: "#00322E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2ColumnIcon);
export default __webpack_public_path__ + "static/media/2column-icon.683baa050ca5125e77a5135c1c33db72.svg";
export { ForwardRef as ReactComponent };